import { ComplexBase } from '@syncfusion/ej2-react-base';
/**
 * `HolidaysDirective` represent a holidays collection in Gantt..
 * It must be contained in a Gantt component(`GanttComponent`).
 * ```tsx
 * <GanttComponent dataSource={data} allowSelection={true} allowSorting={true}>
 * <HolidaysDirective>
 * <HolidayDirective from='02/20/2018' label='Holiday 1'></HolidayDirective>
 * <HolidayDirective from='05/15/2018' label='Holiday 2'></HolidayDirective>
 * </HolidaysDirective>
 * </GanttComponent>
 * ```
 */
export class HolidayDirective extends ComplexBase {
}
HolidayDirective.moduleName = 'holiday';
export class HolidaysDirective extends ComplexBase {
}
HolidaysDirective.propertyName = 'holidays';
HolidaysDirective.moduleName = 'holidays';
